export const demandTypeList = [
    {
        code:'00',
        value:'关键技术研发'
    },
    {
        code:'01',
        value:'产品升级'
    },
    {
        code:'02',
        value:'技术改造'
    },
    {
        code:'03',
        value:'设备改进'
    },
    {
        code:'04',
        value:'技术交易'
    },
    {
        code:'05',
        value:'技术咨询'
    },
    {
        code:'06',
        value:'海外创新合作'
    },
    {
        code:'07',
        value:'科技金融'
    },
    {
        code:'10',
        value:'测试参数'
    },
    {
        code:'11',
        value:'测试方法'
    },
    {
        code:'12',
        value:'测试设备'
    },
    {
        code:'13',
        value:'测试标准'
    },
    {
        code:'99',
        value:'其他'
    },
]